module.exports = __webpack_public_path__ + "static/img/bluecompass-intro.e39802e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/bluecompass-intro.jpg
// module id = zEN3
// module chunks = 0